import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';
import type { CapacityFeeResponse } from '@/types/api';

export interface CapacityFeeParams {
  station: string;
  month: string; // YYYYMM
}

export function useCapacityFee(params: CapacityFeeParams | null) {
  return useQuery({
    queryKey: ['capacity-fee', params],
    queryFn: async () => {
      const res = await apiClient.get<CapacityFeeResponse>('/capacity-fee/calculate', {
        params,
      });
      return res.data;
    },
    enabled: !!params?.station && !!params?.month,
    staleTime: 5 * 60 * 1000,
  });
}
